/**
 * The fields a scene search matches, in one place so that the scenes gallery
 * and the scene switcher in the top bar find the same scenes.
 */
export const SCENE_SEARCH_FIELDS = ["meta.name", "meta.description"];
